/* eslint-disable no-param-reassign */

import { types } from "mobx-state-tree";
import LiveChatModel from "data/models/chat/live";

const LiveChatsModel = types
  .model("LiveChatsModel", {
    items: types.array(LiveChatModel),
  })
  .actions((self) => ({
    set(values) {
      self.items = values;
      return self;
    },

    add(chat) {
      self.items.push(chat);
      return self;
    },

    remove(chatId) {
      self.items = self.items.filter((v) => v.id !== chatId);
      return self;
    },

    removeAll() {
      self.items = [];
      return self;
    },

    sortChatsByOnline() {
      self.items.sort((chat) => !chat.isOnline);
      return self;
    },
  }))
  .views((self) => ({
    get onlyOnline() {
      return self.items.filter((chat) => chat.isOnline);
    },

    byId(chatId) {
      return self.items.find((chat) => chat.id === chatId);
    },

    hasChat(chatId) {
      return self.items.some((chat) => chat.id === chatId);
    },
  }));

export default LiveChatsModel;
